import React, { useEffect, useState } from 'react';
import { parseISO, toDate } from 'date-fns';
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBView,
  MDBRow,
  MDBCol,
  MDBCardBody,
  MDBIcon,
  MDBMedia,
  MDBFileInput,
  MDBSpinner,
  toast,
} from 'mdbreact';

import Compressor from 'compressorjs';
import api from '../../services/api';
import resolverMensagemErro from '../../utils/resolverMensagemErro';
import ArquivoCnh, { useArquivoCnh, BotaoAbrirCnh } from '../ArquivoCnh';
import { aceitaUpload } from '../ArquivoCnh/arquivoCnh';

function ImageMeta(props) {
  const [stateExifImage, setExifImage] = useState(null);
  const [dados, setDad] = useState({});
  const [compressedFileView, setCompressedFileView] = useState(null);
  const [compressedFileBase64, setCompressedFileBase64] = useState(null);

  const [loadingSend, setLoadingSend] = useState(false);
  const [loadingBusca, setLoadingBusca] = useState(false);
  const [loadingHandle, setLoadingHandle] = useState(false);

  const [imagens, setImagens] = useState([]);
  const [imageSelected, setImageSelected] = useState(null);

  // GET /usuario-foto-cnh devolve no máximo um registro (LIMIT 1 no controller).
  const cnhEnviada = useArquivoCnh(
    Array.isArray(imagens) && imagens.length > 0 ? imagens[0].imagem : null
  );
  // const [modalFoto, setModalFoto] = useState({ id: null, base: null });
  // { id: null, base: null }
  // componentizar
  const buscaFotos = async () => {
    setLoadingBusca(true);

    // const result = await api.get('/sgo-imagem', {
    const result = await api.get(props.getFotos.buscaFotosURL, {
      params: {
        //     // abordagem_id: props.abordagem_id,
        ...props.getFotos.buscaFotosWhere,
      },
    });

    setImagens(result.data);
    setLoadingBusca(false);
  };

  useEffect(() => {
    buscaFotos();
  }, []);

  useEffect(() => {
    handleChange(imageSelected);
  }, [imageSelected]);

  // componentizar
  const enviaFoto = async () => {
    setLoadingSend(true);

    // #324: o backend passou a recusar formato e tamanho (400). Sem este
    // try/catch a recusa virava promessa rejeitada em silêncio: nenhuma
    // mensagem na tela e o botão preso em "Carregando..." para sempre.
    try {
      await api.post(props.postFotos.enviarFotoURL, {
        file: compressedFileBase64,
        data: props.postFotos.enviarRefId,
      });

      buscaFotos();
      setCompressedFileBase64(null);
      setCompressedFileView(null);
    } catch (err) {
      toast.error(resolverMensagemErro(err));
    } finally {
      setLoadingSend(false);
    }
  };

  function handleChange(files_list) {
    if (!files_list || files_list.length === 0) return;

    // O input não é `multiple` e o limite é uma imagem: o laço que existia
    // aqui sobrescrevia o próprio estado a cada volta.
    const arquivo = files_list[0];

    const erros = aceitaUpload(arquivo);
    if (erros.length > 0) {
      setCompressedFileView(null);
      setCompressedFileBase64(null);
      toast.error(erros[0]);

      return;
    }

    setLoadingHandle(true);

    // #324: PDF não passa pelo Compressor — ele só sabe reencodar imagem e
    // devolveria um arquivo corrompido. Vai direto para o FileReader.
    if (arquivo.type === 'application/pdf') {
      setCompressedFileView(arquivo);

      const reader = new FileReader();

      reader.readAsDataURL(arquivo);
      reader.onload = () => {
        setCompressedFileBase64(reader.result);
        setLoadingHandle(false);
      };

      return;
    }

    // #324: era 1024px com qualidade 0.6 acima de 200 kB, e CNH escaneada
    // saia ilegivel — nao adianta zoom sobre pixel que nao foi gravado. A
    // troca custa ~1 MB por CNH no BLOB, contra 193 kB antes (ver #323).
    new Compressor(arquivo, {
      quality: 0.85,
      maxHeight: 2048,
      maxWidth: 2048,
      success: compressedResult => {
        setCompressedFileView(compressedResult);

        const reader = new FileReader();

        reader.readAsDataURL(compressedResult);
        reader.onload = () => {
          setCompressedFileBase64(reader.result);
          setLoadingHandle(false);
        };
      },
    });
  }

  return (
    <MDBContainer>
      {loadingBusca && (
        <MDBRow center className="align-items-center my-3">
          <MDBSpinner />
          <div className="ml-3 font-weight-bold">Carregando...</div>
        </MDBRow>
      )}
      <MDBRow>
        {imagens.ok ? (
          <MDBCol center className="py-3 font-weight-bold danger-text">
            {imagens.ok}
          </MDBCol>
        ) : (
          <MDBCol size="12" className="my-2">
            {/* #324: imagem ou PDF — a decisão é do prefixo da data URL.
                Altura menor que a do Perfil: aqui o arquivo divide a tela com
                o seletor de envio, logo abaixo. */}
            <ArquivoCnh cnh={cnhEnviada} altura="45vh" />
          </MDBCol>
        )}
      </MDBRow>

      {/* {imagens > 0 && console.log('console.log', URL.createObjectURL(imagens))} */}
      {/* {imagens > 0 && <img src={URL.createObjectURL(imagens)} />} */}

      {/* ))} */}
      {/* Uma faixa de ações só: trocar o arquivo e abrir o PDF ficam lado a
          lado, em vez de um botão solto por cima do documento. */}
      <MDBRow className="align-items-center justify-content-center">
        <BotaoAbrirCnh cnh={cnhEnviada} />
      </MDBRow>

      {imagens.length < 2 || imagens.ok ? (
        <MDBFileInput
          type="file"
          id="file"
          btnTitle="Selecione"
          textFieldTitle="Buscar imagem ou PDF"
          accept=".jpg, .jpeg, .png, .pdf"
          value={imageSelected}
          getValue={e => {
            setImageSelected(e);
          }}
        />
      ) : (
        <MDBRow center className="font-weight-bold danger-text">
          Limite: {props.maxImages} arquivo(s)
        </MDBRow>
      )}

      <hr />

      {!!compressedFileView && (
        <MDBRow className="align-items-center justify-content-center">
          <MDBCol size="12">
            {loadingHandle ? (
              <div className="d-flex align-items-center justify-content-center">
                <MDBSpinner />
                <div className="ml-3 font-weight-bolder">Carregando...</div>
              </div>
            ) : (
              <>
                {compressedFileView.type === 'application/pdf' ? (
                  // Antes de enviar basta confirmar QUAL arquivo foi escolhido;
                  // o PDF em si aparece renderizado depois do envio, acima.
                  <div className="p-3 border rounded d-inline-block">
                    <MDBIcon far icon="file-pdf" className="mr-2 danger-text" />
                    <span className="font-weight-bold">
                      {compressedFileView.name}
                    </span>
                  </div>
                ) : (
                  <img
                    width="200"
                    height="200"
                    className="img-thumbnail cursor-pointer"
                    src={URL.createObjectURL(compressedFileView)}
                    alt="Pré-visualização do arquivo escolhido"
                  />
                )}
              </>
            )}
          </MDBCol>
          <MDBCol size="12" md="6" className="text-center">
            {loadingSend ? (
              <div className="d-flex align-items-center justify-content-center">
                <MDBSpinner />
                <div className="ml-3 font-weight-bolder">Carregando...</div>
              </div>
            ) : (
              <MDBBtn
                disabled={loadingSend}
                color="dark-green"
                size="sm"
                onClick={() => enviaFoto()}
              >
                Enviar
              </MDBBtn>
            )}
          </MDBCol>
        </MDBRow>
      )}
    </MDBContainer>
  );
}

export default ImageMeta;
